import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { cloneDeep, debounce } from 'lodash';
import { SubscriptionRowNode } from 'src/app/admin/Subscription/subscription-management-model';
import { SubscriptionService } from 'src/app/admin/Subscription/subscription.service';

@Component({
    selector: 'cv-subscription-management-edit',
    templateUrl: './subscription-management-edit.component.html',
    styleUrls: ['./subscription-management-edit.component.scss']
})
export class SubscriptionManagementEditComponent {
    @Input() set subscription(value: SubscriptionRowNode) {
        this._subscription = cloneDeep(value);
        this.name = value.Name;
        this.exportType = value.ExportTypeText;
        this.frequency = value.FrequencyText;
        this.createdBy = value.Creator;
        this.recipients = [...value.Recipients];
    }

    // Returns the saved row on success and null on fail
    @Output() onSaved = new EventEmitter<SubscriptionRowNode>();
    @Output() onClosed = new EventEmitter<void>();

    public name: string;
    public exportType: string;
    public frequency: string;
    public createdBy: string;
    public recipients: string[];
    public newRecipients: string = "";

    public rawFilter: string = "";
    public filter: string = "";
    public isSaving: boolean = false;

    private _subscription: SubscriptionRowNode;

    constructor(private _service: SubscriptionService) {
    }

    public addRecipients() {
        let recipientArr = this.newRecipients.split(',').map((r) => r.trim()).filter((r) => r.length > 0);
        this.recipients.push(...recipientArr);
        this.newRecipients = "";
    }

    public applyFilter = debounce(this.setFilter, 400);

    public clearFilter() {
        this.rawFilter = this.filter = "";
    }

    public close() {
        this.onClosed.emit();
    }

    public removeRecipient(index: number) {
        this.recipients.splice(index, 1);
    }

    public async save() {
        if (this.isSaving)
            return;
        this.isSaving = true;
        this._subscription.Recipients = [...this.recipients];

        let response = await this._service.editSubscription(this._subscription, this._subscription.Type + 1);

        if (!response) {
            console.error("Failed to save legacy subscription.");
            this.isSaving = false;
            return;
        }

        this.onSaved.emit(this._subscription);
        this.newRecipients = "";
        this.recipients = [];
        this.filter = this.rawFilter = "";
        this.isSaving = false;
    }

    private setFilter() {
        this.filter = this.rawFilter.trim();
    }
}
